import Vue from 'vue'
import Router from 'vue-router'
import { mapGetters, mapState } from 'vuex'
// import Storage from '@/utils/storage'

Vue.use(Router)

export default {
  created: function () {
  },
  computed: {
    ...mapGetters( [ 'selectedEnv', 'envList', 'tangoStatus', 'theme' ] ),
    ...mapState({ configList: state => state.user.config }),
    tangoEnvAddress: function () {
      let env = this.selectedEnv ? this.selectedEnv : this.envList[0]
      if (!env) return false
      return 'ws' + (env.ssl ? 's' : '') + '://' + env.host + ':' + env.port
    }
  },
  methods: {
    addMessagesHandler () {
      this.$tango.addListener('tangoDisconnected', this.onDisconnection, this)
    },
    removeMessagesHandler () {
      this.$tango.removeListener('tangoDisconnected', this.onDisconnection, this)
    },
    onDisconnection () {
      this.logout()
    },
    loadConfigTango: function () {
      return this.$store.dispatch('tangoEnv/loadConfig', this).then(() => {
        if(!this.tangoStatus) {
          this.$message({
            message: this.$t('Missing config'),
            type: 'error'
          })
          this.logout()
        }
        else {
          document.body.className = this.theme
        }
      }).then(() => this.getConfigLogo()
      ).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err)
        this.$message({
          message: this.$t('Missing config'),
          type: 'error'
        })
        this.logout()
      })
    },
    getConfigLogo: function () {
      return this.connectToServer().then(() => {
        return this.$tango.searchConfig().then(rep => {
          if (rep.resultCode !== 0 || !rep.configList) {
            this.$message({
              message: this.$t('Error fetching config'),
              type: 'error'
            })
          }
          return this.$store.dispatch('user/setConfig', rep.configList)
        })
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err)
        // reject(err)
      })
    },
    connectToServer: function () {
      if (this.$tango.isConnected()) {
        return this.$tango.getConnection().then(() => this.$tango)
      }
      else {
        return this.$tango.connect(this.tangoEnvAddress).then(() => this.$tango)
      }
    },
    async logout () {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.log('[LOGOUT]')
      }

      await this.$store.dispatch('tangoEnv/close', this)
      await this.$store.dispatch('user/logout')
      await this.$store.commit('RESET_STORE')
      // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      // eslint-disable-next-line no-unused-vars
      this.$router.push({ path: '/login' }).catch(err => {})
    }
  }
}
